import { number, string } from "prop-types";
import { parseSessionTime } from "@utils";
import classnames from "classnames";

export const Timer = ({
  playTime,
  totalTime,
  className,
}) => {
  
  const parsedTime = playTime / 1000;
  const parsedTotalTime = totalTime / 1000;
  
  return (
    <p className={classnames("text-sm font-bold", className)}>
      { parseSessionTime(parsedTime) }
      {" / "}
      { parseSessionTime(parsedTotalTime) }
    </p>
  )
}

Timer.propTypes = {
  playTime: number.isRequired,
  totalTime: number.isRequired,
  className: string,
}